<mat-card>
  <mat-card-title>
    {{ passedMeasureName }} <button mat-icon-button (click)="generateReport()"><mat-icon>file_download</mat-icon></button>
  </mat-card-title>
  <canvas id="myChart"></canvas>
</mat-card>
